import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { useTheme } from '../../../theme';
import { InsurancePage, Props as InsurancePageProps } from '../InsurancePage/InsurancePage';
import { Money as MoneyType } from '../../../Money/types';
import FullscreenDialogClose from '../../../FullscreenDialog/components/Close/Close';
import Toolbar from '../../../Toolbar';

export interface Props extends InsurancePageProps {
	totalPrice: MoneyType;
	onConfirm: () => void;
	onClose: () => void;
}

export const InsurancePageModal: React.FC<Props> = ({ className, totalPrice, onConfirm, onClose, ...props }) => {
	const { t } = useTranslation('InsurancePage');
	const { InsurancePageModal: theme } = useTheme('InsurancePage');

	return (
		<div className={cn(className, theme.container)}>
			<div className={theme.header}>
				<div className={theme.header__wrapper}>
					<div className={theme.title}>{t('Choice of insurance')}</div>
					<FullscreenDialogClose text={t('Back to services')} onClose={onClose} />
				</div>
			</div>
			<InsurancePage {...props} />
			<Toolbar
				innerClassName={theme.footer}
				totalPrice={totalPrice}
				onButtonClick={onConfirm}
				onBackButtonClick={onClose}
			/>
		</div>
	);
};
